import type { RecordUnion } from 'components/framework/models/generated/types';
import User from 'components/framework/models/User';
import RecordAction from '../RecordAction';
import type ApplicationModel from 'components/framework/ApplicationModel';

export class AssignToUserAction extends RecordAction<RecordUnion> {
  recordTypes = ['Epic', 'Feature', 'Requirement'];
  emptySubmenuContent = 'No users available';

  get title() {
    return 'Assign to user';
  }

  get hasSubmenu() {
    return true;
  }

  async prepareSubmenuItems() {
    const currentUserId = window.currentUser?.id;
    const includeAll = !window.currentProject?.isTeam;
    const availableUsers = await User.select(
      'id',
      'name',
      'initials',
      'avatarUrl'
    )
      .where({ projectId: window.currentProject?.id, includeAll })
      .all();

    const currentUserIndex = availableUsers.findIndex(
      user => user.id === currentUserId
    );
    if (currentUserIndex > 0) {
      availableUsers.unshift(availableUsers.splice(currentUserIndex, 1)[0]);
    }

    return [
      { label: 'Unassign', data: { id: null } },
      ...availableUsers.map(user => ({
        label: `${user.name}${user.id === currentUserId ? ' (me)' : ''}`,
        data: user,
      })),
    ];
  }

  showForRecord(record: ApplicationModel): record is RecordUnion {
    return (
      super.showForRecord(record) &&
      (record.project?.id === window.currentProject?.id ||
        record.team?.id === window.currentProject?.id)
    );
  }

  showForSelectedRecords() {
    return !!(
      window.currentProject?.isTeam &&
      this.selectedRecords.every(record => this.showForRecord(record))
    );
  }

  async runForRecords(records, { id }) {
    if (id === undefined) return;

    await this.mutationBatcher.execute(() =>
      records.map(record =>
        record.update(
          {
            assignedToUser: new User({ id }),
          },
          {
            batcher: this.mutationBatcher,
          }
        )
      )
    );
  }
}
